import '@/modules/card';
import Swiper from 'swiper';
import SwiperCore, { Navigation } from 'swiper/core';
import 'swiper/css';
SwiperCore.use([Navigation]);

export default class ProductComparisonCarousel {
    constructor (sliderElement) {
        if (!sliderElement) return;

        this.sliderElement = sliderElement;
        this.arrowNext = this.sliderElement.querySelector('.swiper-button-next');
        this.arrowPrev = this.sliderElement.querySelector('.swiper-button-prev');
        this.scrollbar = this.sliderElement.querySelector('.swiper-scrollbar');

        this.init()
    }

    init() {
        new Swiper(this.sliderElement, {
            slidesPerView: 1.2,
            spaceBetween: 10,
            threshold: 10,
            speed: 400,
            navigation: {
                nextEl: this.arrowNext,
                prevEl: this.arrowPrev
            },
            breakpoints: {
                768: {
                    slidesPerView: 3,
                },
                1024: {
                    slidesPerView: 3.7,
                    spaceBetween: 0
                }
            }
        });
    }
}